import classNames from "classnames";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { useAppSelector } from "app/hooks";
import BadgeBarcode from "ui/components/barcodes/badge";
import ModMedBarcode from "ui/components/barcodes/modmed";

const PrintPage = () => {
  const { object, payload } = useParams();
  const [searchParams] = useSearchParams();

  const singlePage = useAppSelector((state) =>
    selectFeatureFlag(state, "singlePageBarcodePrinting")
  );

  useEffect(() => {
    if (window.opener) {
      const closeWindow = () => {
        window.close();
      };
      window.addEventListener("afterprint", closeWindow);

      return () => {
        window.removeEventListener("afterprint", closeWindow);
      };
    }
  }, []);

  useEffect(() => {
    if (window.opener) {
      const print = () => {
        setTimeout(() => window.print(), 250);
      };
      if (document.readyState === "complete") {
        print();
      } else {
        window.addEventListener("load", print);
        return () => window.removeEventListener("load", print);
      }
    }
  }, []);

  return (
    <div className={classNames("Print", { SinglePagePrint: singlePage })}>
      {payload?.split(",").map((barcode) => (
        <div
          className={`DecoratedBarcode DecoratedBarcode--${object}`}
          key={barcode}
        >
          {object === "badge" && (
            <BadgeBarcode payload={barcode} name={searchParams.get("name")} />
          )}
          {object === "modmed" && <ModMedBarcode payload={barcode} />}
        </div>
      ))}
    </div>
  );
};

export default PrintPage;
